import styled from 'styled-components';

export const PartyJackpotWelcomePopupDescriptionBox = styled.div`
    font-size: 1.2em;
    white-space: pre-line;
`;
